interface SummaryCardProps {
  label: string;
  value: string;
  loading?: boolean;
}

export const SummaryCard = ({ label, value, loading }: SummaryCardProps) => {
  return (
    <div className="flex-1 rounded-xl border border-gray-200 bg-white px-4 py-3">
      <div className="text-xs font-medium uppercase text-gray-500">{label}</div>
      <div className="mt-1 text-2xl font-semibold text-gray-900">{loading ? '—' : value}</div>
    </div>
  );
};
